import React from 'react';
import { useLocale } from '../../contexts/LocaleContext';

const CONTACT_EMAIL = 'pankaj6apr@outlook.com';

type PrivacyPrefix = 'privacyAInstein' | 'privacyEunoia' | 'privacyRoamr' | 'privacyVoPub';

interface PrivacyPolicyContentProps {
  prefix: PrivacyPrefix;
}

const sectionStyle: React.CSSProperties = {
  marginBottom: '2rem',
  padding: 0,
};
const h2Style: React.CSSProperties = {
  fontSize: '1.4rem',
  fontWeight: 600,
  margin: '2rem 0 1rem 0',
  padding: 0,
};
const h3Style: React.CSSProperties = {
  fontSize: '1.1rem',
  fontWeight: 600,
  margin: '1.5rem 0 0.75rem 0',
};
const pStyle: React.CSSProperties = {
  margin: '0 0 1rem 0',
};
const ulStyle: React.CSSProperties = {
  margin: '0 0 1rem 1.5rem',
  padding: 0,
  listStylePosition: 'outside',
};
const liStyle: React.CSSProperties = {
  margin: 0,
  padding: '0.1em 0',
  lineHeight: 1.35,
};

const PrivacyPolicyContent: React.FC<PrivacyPolicyContentProps> = ({ prefix }) => {
  const { t } = useLocale();

  const renderList = (listKey: string) => {
    const text = t(listKey);
    if (!text || text === listKey) return null;
    const items = text.split('\n').filter(Boolean);
    return (
      <ul style={ulStyle}>
        {items.map((item, i) => (
          <li key={i} style={liStyle}>{item}</li>
        ))}
      </ul>
    );
  };

  return (
    <div style={{ lineHeight: 1.6 }}>
      <h1 style={{ fontSize: '1.8rem', fontWeight: 600, margin: '0 0 1rem 0', padding: 0, lineHeight: 1.2 }}>
        {t(`${prefix}Title`)}
      </h1>
      <p style={{ margin: '0 0 2rem 0', color: '#666' }}>{t(`${prefix}EffectiveDate`)}</p>
      <p style={pStyle}>{t(`${prefix}Intro`)}</p>

      <section style={sectionStyle}>
        <h2 style={h2Style}>{t(`${prefix}Section1Title`)}</h2>
        <h3 style={h3Style}>{t(`${prefix}Section1aTitle`)}</h3>
        <p style={pStyle}>{t(`${prefix}Section1aIntro`)}</p>
        {renderList(`${prefix}Section1aList`)}
        <h3 style={h3Style}>{t(`${prefix}Section1bTitle`)}</h3>
        <p style={pStyle}>{t(`${prefix}Section1bIntro`)}</p>
        {renderList(`${prefix}Section1bList`)}
        <h3 style={h3Style}>{t(`${prefix}Section1cTitle`)}</h3>
        <p style={pStyle}>{t(`${prefix}Section1cIntro`)}</p>
        {renderList(`${prefix}Section1cList`)}
        {renderList(`${prefix}Section1dList`) && (
          <>
            <h3 style={h3Style}>{t(`${prefix}Section1dTitle`)}</h3>
            <p style={pStyle}>{t(`${prefix}Section1dIntro`)}</p>
            {renderList(`${prefix}Section1dList`)}
          </>
        )}
      </section>

      <section style={sectionStyle}>
        <h2 style={h2Style}>{t(`${prefix}Section2Title`)}</h2>
        <p style={pStyle}>{t(`${prefix}Section2Intro`)}</p>
        {renderList(`${prefix}Section2List`)}
      </section>

      <section style={sectionStyle}>
        <h2 style={h2Style}>{t(`${prefix}Section3Title`)}</h2>
        <p style={pStyle}>{t(`${prefix}Section3Intro`)}</p>
        {renderList(`${prefix}Section3List`)}
      </section>

      <section style={sectionStyle}>
        <h2 style={h2Style}>{t(`${prefix}Section4Title`)}</h2>
        <p style={pStyle}>{t(`${prefix}Section4P1`)}</p>
        <p style={pStyle}>{t(`${prefix}Section4P2`)}</p>
      </section>

      <section style={sectionStyle}>
        <h2 style={h2Style}>{t(`${prefix}Section5Title`)}</h2>
        <p style={pStyle}>{t(`${prefix}Section5Content`)}</p>
      </section>

      <section style={sectionStyle}>
        <h2 style={h2Style}>{t(`${prefix}Section6Title`)}</h2>
        <p style={pStyle}>{t(`${prefix}Section6Intro`)}</p>
        {renderList(`${prefix}Section6List`)}
        <p style={pStyle}>{t(`${prefix}Section6P2`)}</p>
      </section>

      <section style={sectionStyle}>
        <h2 style={h2Style}>{t(`${prefix}Section7Title`)}</h2>
        <p style={pStyle}>{t(`${prefix}Section7Intro`)}</p>
        {renderList(`${prefix}Section7List`)}
      </section>

      <section style={sectionStyle}>
        <h2 style={h2Style}>{t(`${prefix}Section8Title`)}</h2>
        <p style={pStyle}>{t(`${prefix}Section8Content`)}</p>
      </section>

      <section style={sectionStyle}>
        <h2 style={h2Style}>{t(`${prefix}Section9Title`)}</h2>
        <p style={pStyle}>{t(`${prefix}Section9Intro`)}</p>
        <p style={{ margin: 0 }}>
          <a href={`mailto:${CONTACT_EMAIL}`} style={{ color: '#4f46e5', textDecoration: 'none', fontWeight: 500 }}>
            {CONTACT_EMAIL}
          </a>
        </p>
      </section>
    </div>
  );
};

export default PrivacyPolicyContent;
